<template>
  <div>
    <!-- Footer Section start -->
    <div class="copyright-section index-footer bg-light">
      <p>2023  TargetFinance LLC</p>
    </div>
    <!-- Footer Section End -->
    <!-- Tap on Top -->
    <div class="tap-top">
      <div>
        <i class="fa fa-angle-double-up"></i>
      </div>
    </div>
    <!-- Tap on Ends -->
    <color/>
  </div>
</template>
<script>
export default {
  name: 'Footer'
}
</script>



// WEBPACK FOOTER //
// src/components/footer.vue